export default "__VITE_ASSET__DGoP3EDH__"